import instance, { ApiResponse } from 'api';
import { AxiosError, AxiosResponse } from 'axios';
import { BaseApi } from 'baseApi';
import { endpoints } from 'endpoints.config';
import { IProfileDeatilsForm, ProfileParser } from 'pages/profile/models';

const UNKOWN_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again.';

export class ProfileApi extends BaseApi {
  // get profile information
  public static getProfileDetails = async (): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.get(
        endpoints.profile.profileDetails
      );

      if (ProfileApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return ProfileApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          //TODO: build error parser
          // const message = UsersParser.parseError(errors);
          // return UsersApi.errorResponse(message);
          return null;
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.errors;
        if (errors) {
          //TODO: build error parser
          // const message = UsersParser.parseError(errors);
          // return UsersApi.errorResponse(message);
          return null;
        }
      }
      return ProfileApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };

  // update email preferences
  public static updateEmailPreferences = async (values: {
    bEmailAlerts: boolean;
  }): Promise<any> => {
    try {
      const payload = values;
      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.profile.updateemailpreferences,
        payload
      );

      if (ProfileApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return ProfileApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          //TODO: build error parser
          // const message = UsersParser.parseError(errors);
          // return UsersApi.errorResponse(message);
          return null;
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.errors;
        if (errors) {
          //TODO: build error parser
          // const message = UsersParser.parseError(errors);
          // return UsersApi.errorResponse(message);
          return null;
        }
      }
      return ProfileApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };

  // update Profile details
  public static updateProfileDetails = async (
    values: IProfileDeatilsForm
  ): Promise<any> => {
    try {
      const payload = values;
      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.profile.updateprofile,
        payload
      );

      if (ProfileApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return ProfileApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          const message = ProfileParser.parseError(errors);
          return ProfileApi.errorResponse(message);
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          const message = ProfileParser.parseError(errors);
          return ProfileApi.errorResponse(message);
        }
      }
      return ProfileApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };
}
